import React from 'react'
import { getFullName } from './../../formatters'
import isFlagOn from './../../../../shared/utilities/isFlagOn.function'
import StateLicenseMap from './../../../../components/agents/StateLicenseMap/StateLicenseMap.component'

import './Testimonials.scss'

const Quote = ({ item }) =>
  item ? (
    <blockquote className='why-quote'>
      <p>“{item.testimonial}”</p>
      {item.author ? <cite>– {item.author}</cite> : <></>}
    </blockquote>
  ) : (
    <></>
  )

const AgentTestimonials = props => {
  const fullName = getFullName(props?.data)
  const testimonials = Array.isArray(props?.data?.testimonials) ? props.data.testimonials : []
  const licenses = Array.isArray(props?.licenses) ? props.licenses : []
  const login = props?.data?.u_login
  const showLicenseMap = isFlagOn(props?.data?.s_state_license_show)

  // Split the first few testimonials to flank the map (Duda layout)
  const left = [testimonials[0], testimonials[2]].filter(Boolean)
  const right = [testimonials[1], testimonials[3]].filter(Boolean)

  return (
    <section id='testimonials' className='subsite-section'>
      <div className='subsite-shell'>
        <h2 className='subsite-section-title'>
          {fullName ? `Why Clients Choose ${fullName}` : 'Why Clients Choose Us'}
        </h2>
        <div className='why-grid'>
          <div className='why-col why-col-left'>
            {left.map((item, i) => (
              <Quote item={item} key={`tl-${i}`} />
            ))}
          </div>
          {showLicenseMap ? (
            <div className='why-map'>
              <a
                href={login ? `/${login}/licenses` : '#'}
                target='_blank'
                rel='noopener noreferrer'
                className='why-map-link'
                aria-label='View agent state licenses'
              >
                <StateLicenseMap licenses={licenses} clickable={false} />
              </a>
              <a
                href={login ? `/${login}/licenses` : '#'}
                target='_blank'
                rel='noopener noreferrer'
                className='why-map-cta'
              >
                View My State Licenses
              </a>
            </div>
          ) : (
            <></>
          )}
          <div className='why-col why-col-right'>
            {right.map((item, i) => (
              <Quote item={item} key={`tr-${i}`} />
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default AgentTestimonials
